awardCalculation.classy.controller({
    name: 'UtilitiesController',
    inject: ['$scope', 'RestService', '$q', 'ApplicationService', 'CalculationService', 'EditSumsService', 'FamilyThresholdsService', 'CalculationService', 
        'ModelService', 'BinFactory', 'DateService', 'ResetService'],
    init: function()
    {
        this.$.isArchive = this.BinFactory.isArchive();
        this.$.DateService = this.DateService;
        this.$.ResetService = this.ResetService;
    },
    utilitiesPut: function(scope, instance, form)
    {
        instance.options.factor = .3;
        var parent = this;
        var dataThresh = this.ApplicationService.getFamilyData().thresholds;
        var dataEditSums = this.ApplicationService.getFamilyData().edit_sums;

        var putDataThresh = {};
        var putDataEditSums = {};


        putDataThresh.Thresh_Utilities_Percent = dataThresh.Thresh_Utilities_Percent;
        putDataThresh.Thresh_Utilities_Cap = dataThresh.Thresh_Utilities_Cap;

        putDataEditSums.Exp_Elec = dataEditSums.Exp_Elec;
        putDataEditSums.Exp_Heat = dataEditSums.Exp_Heat;

        putDataThresh.familyID = dataThresh.familyID;
        putDataThresh.applicationID = dataEditSums.applicationID;
        putDataEditSums.familyID = dataEditSums.familyID;
        putDataEditSums.applicationID = dataEditSums.applicationID;
            return this.$q.all([
                this.EditSumsService.put(putDataEditSums),
                this.FamilyThresholdsService.put(putDataThresh)
            ]).then(function (data, status, headers, config) {
            parent.CalculationService.reCalc();
            var works = 0;
            if (data[0].status == 200) 
                works++;
            if (data[1].status == 200) 
                works++
            if (works>0)
                instance.stop(1);
            else 
                instance.stop(-1)
            //instance.options.callMe(data, status, headers, config, instance);
        });
        /*this.ModelService.FamilyThreshEditSumsService.putHelper(dataThresh, dataEditSums,
            putDataThresh, putDataEditSums, this.CalculationService.reCalc);*/
    },
    IntroOptions: function()
    {
        return {
            steps: this.CalculationService.intro_utilities(),
            showStepNumbers: false,
            showBullets: false,
            exitOnOverlayClick: true,
            exitOnEsc:true,
            nextLabel: '<strong>NEXT!</strong>',
            prevLabel: '<span style="color:green">Previous</span>',
            skipLabel: 'Exit',
            doneLabel: 'Thanks'
        };
    }
});
